module.exports = __webpack_public_path__ + "img/WX20230915-135101@2x.e3e6a5bf.png";